import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withModifiers as _withModifiers, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "presenter-view" }
const _hoisted_2 = { class: "toolbar" }
const _hoisted_3 = { class: "content" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "remark" }
const _hoisted_6 = { class: "header" }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "remark-scale" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconListView = _resolveComponent("IconListView")!
  const _component_IconWrite = _resolveComponent("IconWrite")!
  const _component_IconMagic = _resolveComponent("IconMagic")!
  const _component_Divider = _resolveComponent("Divider")!
  const _component_IconPower = _resolveComponent("IconPower")!
  const _component_ScreenSlideList = _resolveComponent("ScreenSlideList")!
  const _component_WritingBoardTool = _resolveComponent("WritingBoardTool")!
  const _component_ThumbnailSlide = _resolveComponent("ThumbnailSlide")!
  const _component_IconMinus = _resolveComponent("IconMinus")!
  const _component_IconPlus = _resolveComponent("IconPlus")!
  const _directive_contextmenu = _resolveDirective("contextmenu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "tool-btn",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeViewMode('base')))
      }, [
        _createVNode(_component_IconListView, { class: "tool-icon" }),
        _cache[11] || (_cache[11] = _createElementVNode("span", null, "普通视图", -1))
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["tool-btn", { 'active': _ctx.writingBoardToolVisible }]),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.writingBoardToolVisible = !_ctx.writingBoardToolVisible))
      }, [
        _createVNode(_component_IconWrite, { class: "tool-icon" }),
        _cache[12] || (_cache[12] = _createElementVNode("span", null, "画笔", -1))
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(["tool-btn", { 'active': _ctx.laserPen }]),
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.laserPen = !_ctx.laserPen))
      }, [
        _createVNode(_component_IconMagic, { class: "tool-icon" }),
        _cache[13] || (_cache[13] = _createElementVNode("span", null, "激光笔", -1))
      ], 2),
      _createVNode(_component_Divider, { class: "divider" }),
      _createElementVNode("div", {
        class: "tool-btn",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.exitScreening()))
      }, [
        _createVNode(_component_IconPower, { class: "tool-icon" }),
        _cache[14] || (_cache[14] = _createElementVNode("span", null, "结束放映", -1))
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", {
        class: _normalizeClass(["slide-list-wrap", { 'laser-pen': _ctx.laserPen }]),
        ref: "slideListWrapRef"
      }, [
        _withDirectives(_createVNode(_component_ScreenSlideList, {
          slideWidth: _ctx.slideWidth,
          slideHeight: _ctx.slideHeight,
          animationIndex: _ctx.animationIndex,
          turnSlideToId: _ctx.turnSlideToId,
          manualExitFullscreen: _ctx.manualExitFullscreen,
          onWheel: _cache[4] || (_cache[4] = $event => _ctx.mousewheelListener($event)),
          onTouchstart: _cache[5] || (_cache[5] = $event => _ctx.touchStartListener($event)),
          onTouchend: _cache[6] || (_cache[6] = $event => _ctx.touchEndListener($event))
        }, null, 8, ["slideWidth", "slideHeight", "animationIndex", "turnSlideToId", "manualExitFullscreen"]), [
          [_directive_contextmenu, _ctx.contextmenus]
        ]),
        (_ctx.writingBoardToolVisible)
          ? (_openBlock(), _createBlock(_component_WritingBoardTool, {
              key: 0,
              slideWidth: _ctx.slideWidth,
              slideHeight: _ctx.slideHeight,
              position: {
            left: '75px',
            top: '5px',
          },
              onClose: _cache[7] || (_cache[7] = ($event: any) => (_ctx.writingBoardToolVisible = false))
            }, null, 8, ["slideWidth", "slideHeight"]))
          : _createCommentVNode("", true)
      ], 2),
      _createElementVNode("div", {
        class: "thumbnails",
        ref: "thumbnailsRef",
        onWheel: _cache[8] || (_cache[8] = _withModifiers($event => _ctx.handleMousewheelThumbnails($event), ["prevent"]))
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.slides, (slide, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["thumbnail", { 'active': index === _ctx.slideIndex }]),
            key: slide.id,
            onClick: ($event: any) => (_ctx.turnSlideToIndex(index))
          }, [
            _createVNode(_component_ThumbnailSlide, {
              slide: slide,
              size: 120 / _ctx.viewportRatio,
              visible: index < _ctx.slidesLoadLimit
            }, null, 8, ["slide", "size", "visible"])
          ], 10, _hoisted_4))
        }), 128))
      ], 544)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _cache[15] || (_cache[15] = _createElementVNode("span", null, "演讲者备注", -1)),
        _createElementVNode("span", null, "P " + _toDisplayString(_ctx.slideIndex + 1) + " / " + _toDisplayString(_ctx.slides.length), 1)
      ]),
      _createElementVNode("div", {
        class: "remark-content",
        style: _normalizeStyle({ fontSize: _ctx.remarkFontSize + 'px' }),
        innerHTML: _ctx.currentSlideRemark
      }, null, 12, _hoisted_7),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", {
          class: _normalizeClass(['scale-btn', { 'disable': _ctx.remarkFontSize === 12 }]),
          onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.setRemarkFontSize(_ctx.remarkFontSize - 2)))
        }, [
          _createVNode(_component_IconMinus)
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(['scale-btn', { 'disable': _ctx.remarkFontSize === 40 }]),
          onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.setRemarkFontSize(_ctx.remarkFontSize + 2)))
        }, [
          _createVNode(_component_IconPlus)
        ], 2)
      ])
    ])
  ]))
}